import React from 'react';
import { Upload, FileText, Calendar, Clock, CheckCircle2, ChevronDown, Wallet, DollarSign, TrendingUp, BarChart3, Building2, Info } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, AreaChart, Area, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// Card Revenue Data - Showing decline from $1.5M/month to $1.0M/month
const cardRevenueData = [{
  month: 'Jan-24',
  revenue: 1.45
}, {
  month: 'Feb-24',
  revenue: 1.48
}, {
  month: 'Mar-24',
  revenue: 1.52
}, {
  month: 'Apr-24',
  revenue: 1.5
}, {
  month: 'May-24',
  revenue: 1.54
}, {
  month: 'Jun-24',
  revenue: 1.56
}, {
  month: 'Jul-24',
  revenue: 1.58
}, {
  month: 'Aug-24',
  revenue: 1.52
}, {
  month: 'Sep-24',
  revenue: 1.48
}, {
  month: 'Oct-24',
  revenue: 1.42
}, {
  month: 'Nov-24',
  revenue: 1.35
}, {
  month: 'Dec-24',
  revenue: 1.28
}, {
  month: 'Jan-25',
  revenue: 1.22
}, {
  month: 'Feb-25',
  revenue: 1.15
}, {
  month: 'Mar-25',
  revenue: 1.08
}, {
  month: 'Apr-25',
  revenue: 1.54
}, {
  month: 'May-25',
  revenue: 1.52
}, {
  month: 'Jun-25',
  revenue: 1.5
}, {
  month: 'Jul-25',
  revenue: 1.48
}, {
  month: 'Aug-25',
  revenue: 1.42
}, {
  month: 'Sep-25',
  revenue: 1.35
}, {
  month: 'Oct-25',
  revenue: 1.28
}, {
  month: 'Nov-25',
  revenue: 1.18
}, {
  month: 'Dec-25',
  revenue: 1.08
}, {
  month: 'Jan-26',
  revenue: 1.02
}, {
  month: 'Feb-26',
  revenue: 0.98
}, {
  month: 'Mar-26',
  revenue: 0.95
}];
// Days Beyond Terms Data - Showing spike from 15 to 45 days
const dbtData = [{
  month: 'Apr-25',
  dbt: 15,
  industry: 12,
  yourAR: 12
}, {
  month: 'May-25',
  dbt: 16,
  industry: 11,
  yourAR: 14
}, {
  month: 'Jun-25',
  dbt: 18,
  industry: 12,
  yourAR: 16
}, {
  month: 'Jul-25',
  dbt: 20,
  industry: 12,
  yourAR: 18
}, {
  month: 'Aug-25',
  dbt: 24,
  industry: 13,
  yourAR: 22
}, {
  month: 'Sep-25',
  dbt: 28,
  industry: 13,
  yourAR: 26
}, {
  month: 'Oct-25',
  dbt: 32,
  industry: 14,
  yourAR: 30
}, {
  month: 'Nov-25',
  dbt: 36,
  industry: 14,
  yourAR: 34
}, {
  month: 'Dec-25',
  dbt: 38,
  industry: 15,
  yourAR: 36
}, {
  month: 'Jan-26',
  dbt: 42,
  industry: 15,
  yourAR: 40
}, {
  month: 'Feb-26',
  dbt: 44,
  industry: 16,
  yourAR: 42
}, {
  month: 'Mar-26',
  dbt: 45,
  industry: 16,
  yourAR: 44
}];
// Trade Payment Aging Data - Showing severe past due
const paidData = [{
  name: 'Current',
  value: 3200000
}, {
  name: '1-30',
  value: 1800000
}, {
  name: '31-60',
  value: 950000
}, {
  name: '61-90',
  value: 620000
}, {
  name: '91+',
  value: 430000
}];
const outstandingData = [{
  name: 'Current',
  value: 280000
}, {
  name: '1-30',
  value: 350000
}, {
  name: '31-60',
  value: 480000
}, {
  name: '61-90',
  value: 420000
}, {
  name: '91+',
  value: 280000
}];
// Trade Spend by Industry Data - IT/Software focus
const tradeSpendData = [{
  name: 'IT & Technology',
  value: 620000,
  color: '#4f46e5',
  percentage: 34
}, {
  name: 'Software & Cloud Services',
  value: 540000,
  color: '#10b981',
  percentage: 30
}, {
  name: 'Office Supplies & Equipment',
  value: 290000,
  color: '#8b5cf6',
  percentage: 16
}];
// Payment Aging by Industry Data - Showing deterioration
const paymentAgingData = [{
  industry: 'IT & Technology',
  total: '$620K',
  trades: 18,
  current: 42,
  days1to30: 28,
  days31to60: 18,
  days61to90: 8,
  days91plus: 4
}, {
  industry: 'Software & Cloud Services',
  total: '$540K',
  trades: 12,
  current: 38,
  days1to30: 24,
  days31to60: 22,
  days61to90: 12,
  days91plus: 4
}, {
  industry: 'Office Supplies & Equipment',
  total: '$290K',
  trades: 22,
  current: 48,
  days1to30: 26,
  days31to60: 16,
  days61to90: 7,
  days91plus: 3
}];
export function InitechFinancialsTab() {
  return <div className="space-y-6 mt-6" data-id="element-2066">
      {/* Financial Statement Analysis */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-2067">
        <div className="flex justify-between items-start mb-8" data-id="element-2068">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-2069">
            Financial Statement Analysis
          </h2>
          <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2.5 rounded-lg flex items-center gap-2 font-medium text-sm transition-colors" data-id="element-2070">
            <Upload className="w-4 h-4" data-id="element-2071" />
            UPLOAD FINANCIAL STATEMENT
          </button>
        </div>

        {/* Financial Statement Box */}
        <div className="border border-gray-200 bg-gray-50 rounded-lg p-5 mb-8" data-id="element-2072">
          <p className="text-sm font-medium text-gray-500 mb-3 uppercase tracking-wider" data-id="element-2073">
            Latest Financial Statement
          </p>
          <div className="flex items-center justify-between bg-white p-4 rounded border border-gray-200 shadow-sm" data-id="element-2074">
            <div className="flex items-center gap-6" data-id="element-2075">
              <div className="flex items-center gap-3" data-id="element-2076">
                <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center" data-id="element-2077">
                  <FileText className="w-5 h-5 text-indigo-600" data-id="element-2078" />
                </div>
                <span className="font-semibold text-gray-900 text-lg" data-id="element-2079">
                  Initech-Financial-Statement-2025-Q4
                </span>
              </div>
              <div className="h-6 w-px bg-gray-300" data-id="element-2080"></div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-2081">
                <Calendar className="w-4 h-4" data-id="element-2082" />
                <span className="font-medium" data-id="element-2083">2025</span>
              </div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-2084">
                <Clock className="w-4 h-4" data-id="element-2085" />
                <span className="font-medium" data-id="element-2086">Q4</span>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-2087">
              <div className="flex items-center gap-1.5 bg-green-50 px-3 py-1.5 rounded-full border border-green-200" data-id="element-2088">
                <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-2089" />
                <span className="text-green-700 font-medium text-sm" data-id="element-2090">
                  Completed
                </span>
              </div>
              <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-2091">
                <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-2092" />
              </button>
            </div>
          </div>
        </div>

        {/* Ratio Cards - All 5 in one row - POOR RATIOS */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-id="element-2093">
          {/* Liquidity Ratios - POOR */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-2094">
            <div className="flex items-center gap-2 mb-4" data-id="element-2095">
              <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center" data-id="element-2096">
                <Wallet className="w-4 h-4 text-blue-600" data-id="element-2097" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-2098">Liquidity</h3>
            </div>
            <div className="space-y-3" data-id="element-2099">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2100">
                <span className="text-xs text-gray-600" data-id="element-2101">Current Ratio</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2102">0.92</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2103">
                <span className="text-xs text-gray-600" data-id="element-2104">Quick Ratio</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2105">0.68</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-2106">
                <span className="text-xs text-gray-600" data-id="element-2107">Working Capital</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2108">-$1.2M</span>
              </div>
            </div>
          </div>

          {/* Cash Flow Ratios - NEGATIVE */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-2109">
            <div className="flex items-center gap-2 mb-4" data-id="element-2110">
              <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center" data-id="element-2111">
                <DollarSign className="w-4 h-4 text-green-600" data-id="element-2112" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-2113">Cash Flow</h3>
            </div>
            <div className="space-y-3" data-id="element-2114">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2115">
                <span className="text-xs text-gray-600" data-id="element-2116">Op. Cash Flow</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2117">-0.42</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2118">
                <span className="text-xs text-gray-600" data-id="element-2119">Free Cash Flow</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2120">-$850K</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-2121">
                <span className="text-xs text-gray-600" data-id="element-2122">CF Coverage</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2123">0.18</span>
              </div>
            </div>
          </div>

          {/* Profitability Ratios - NEGATIVE */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-2124">
            <div className="flex items-center gap-2 mb-4" data-id="element-2125">
              <div className="w-8 h-8 bg-purple-50 rounded-lg flex items-center justify-center" data-id="element-2126">
                <TrendingUp className="w-4 h-4 text-purple-600" data-id="element-2127" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-2128">Profitability</h3>
            </div>
            <div className="space-y-3" data-id="element-2129">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2130">
                <span className="text-xs text-gray-600" data-id="element-2131">Net Margin</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2132">-0.12</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2133">
                <span className="text-xs text-gray-600" data-id="element-2134">ROE</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2135">-0.28</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-2136">
                <span className="text-xs text-gray-600" data-id="element-2137">Gross Margin</span>
                <span className="font-bold text-sm text-orange-600" data-id="element-2138">0.18</span>
              </div>
            </div>
          </div>

          {/* Efficiency Ratios - POOR */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-2139">
            <div className="flex items-center gap-2 mb-4" data-id="element-2140">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center" data-id="element-2141">
                <BarChart3 className="w-4 h-4 text-orange-600" data-id="element-2142" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-2143">Efficiency</h3>
            </div>
            <div className="space-y-3" data-id="element-2144">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2145">
                <span className="text-xs text-gray-600" data-id="element-2146">Inv. Turnover</span>
                <span className="font-bold text-sm text-orange-600" data-id="element-2147">3.20</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2148">
                <span className="text-xs text-gray-600" data-id="element-2149">AR Turnover</span>
                <span className="font-bold text-sm text-orange-600" data-id="element-2150">4.80</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-2151">
                <span className="text-xs text-gray-600" data-id="element-2152">DSO</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2153">76.04</span>
              </div>
            </div>
          </div>

          {/* Solvency Ratios - DISTRESS */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-2154">
            <div className="flex items-center gap-2 mb-4" data-id="element-2155">
              <div className="w-8 h-8 bg-teal-50 rounded-lg flex items-center justify-center" data-id="element-2156">
                <Building2 className="w-4 h-4 text-teal-600" data-id="element-2157" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-2158">Solvency</h3>
            </div>
            <div className="space-y-3" data-id="element-2159">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2160">
                <span className="text-xs text-gray-600" data-id="element-2161">Debt-to-Equity</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2162">3.20</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-2163">
                <span className="text-xs text-gray-600" data-id="element-2164">Z-Score</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2165">1.20</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-2166">
                <span className="text-xs text-gray-600" data-id="element-2167">Int. Coverage</span>
                <span className="font-bold text-sm text-red-600" data-id="element-2168">0.85</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Card Revenue Metrics - DECLINING */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-2169">
        <h2 className="text-xl font-bold text-gray-900 mb-8" data-id="element-2170">
          Card Revenue Metrics
        </h2>

        {/* Summary Stats - More compact layout */}
        <div className="flex flex-wrap justify-between items-center gap-4 mb-6 bg-gray-50 p-4 rounded-lg border border-gray-100" data-id="element-2171">
          <div className="flex flex-col" data-id="element-2172">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-2173">
              $1.2M
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2174">
              Annual Card Revenue
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-2175"></div>
          <div className="flex flex-col" data-id="element-2176">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-2177">
              2.1K
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2178">
              Transactions
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-2179"></div>
          <div className="flex flex-col" data-id="element-2180">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-2181">
              $571
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2182">
              Avg Ticket Size
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-2183"></div>
          <div className="flex flex-col" data-id="element-2184">
            <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-2185">
              0 - 12
            </span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2186">
              Daily Transactions
            </span>
          </div>
          <div className="w-px h-8 bg-gray-200 hidden md:block" data-id="element-2187"></div>
          <div className="flex flex-col" data-id="element-2188">
            <span className="text-2xl font-bold text-red-600 mb-0.5" data-id="element-2189">-35%</span>
            <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2190">
              YoY Growth
            </span>
          </div>
        </div>

        {/* Area Chart - Showing decline */}
        <div className="h-80 w-full" data-id="element-2191">
          <ResponsiveContainer width="100%" height="100%" data-id="element-2192">
            <AreaChart data={cardRevenueData} margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 0
          }} data-id="element-2193">
              <defs data-id="element-2194">
                <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1" data-id="element-2195">
                  <stop offset="5%" stopColor="#dc2626" stopOpacity={0.3} data-id="element-2196" />
                  <stop offset="95%" stopColor="#dc2626" stopOpacity={0} data-id="element-2197" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-2198" />
              <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} interval={3} dy={10} data-id="element-2199" />
              <YAxis axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} domain={[0, 2]} ticks={[0, 0.5, 1, 1.5, 2]} tickFormatter={value => `$${value}M`} data-id="element-2200" />
              <Tooltip formatter={(value: any) => `$${Number(value).toFixed(2)}M`} contentStyle={{
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              padding: '12px'
            }} data-id="element-2201" />
              <Area type="monotone" dataKey="revenue" stroke="#dc2626" strokeWidth={3} fillOpacity={1} fill="url(#colorRevenue)" activeDot={{
              r: 6,
              fill: '#dc2626',
              stroke: '#fff',
              strokeWidth: 2
            }} data-id="element-2202" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Trade Payment Information */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8" data-id="element-2203">
        {/* Trade Credit - DETERIORATING */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 lg:col-span-2" data-id="element-2204">
          <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-2205">Trade Credit</h2>
          <div className="grid grid-cols-2 gap-x-6 gap-y-4" data-id="element-2206">
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2207">
              <span className="text-2xl font-bold text-gray-900 mb-0.5" data-id="element-2208">
                $15K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2209">
                Recommended Credit Limit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2210">
              <span className="text-2xl font-bold text-red-600 mb-0.5" data-id="element-2211">45</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2212">
                Days Beyond Terms
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2213">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-2214">70</span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2215">
                Trade Experiences
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2216">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-2217">
                $1.81M
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2218">
                Total Trades Balance
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2219">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-2220">
                $95K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2221">
                Recent High Credit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2222">
              <span className="text-xl font-bold text-gray-900 mb-0.5" data-id="element-2223">
                $25.9K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2224">
                Average Credit Amount
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2225">
              <span className="text-xl font-bold text-red-600 mb-0.5" data-id="element-2226">
                $700K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2227">
                Past Due
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-3" data-id="element-2228">
              <span className="text-xl font-bold text-red-600 mb-0.5" data-id="element-2229">
                38.7%
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2230">
                Past Due %
              </span>
            </div>
            <div className="flex flex-col" data-id="element-2231">
              <span className="text-xl font-bold text-red-600 mb-0.5" data-id="element-2232">
                $280K
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2233">
                Severely Past Due
              </span>
            </div>
            <div className="flex flex-col" data-id="element-2234">
              <span className="text-xl font-bold text-red-600 mb-0.5" data-id="element-2235">
                15.5%
              </span>
              <span className="text-xs font-medium text-gray-500" data-id="element-2236">
                Severely Past Due %
              </span>
            </div>
          </div>
        </div>

        {/* Days Beyond Terms Chart - SPIKING */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6 flex flex-col lg:col-span-3" data-id="element-2237">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-3 gap-3" data-id="element-2238">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-2239">
              Days Beyond Terms
            </h2>
            <div className="flex flex-wrap items-center gap-3 text-xs bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-100" data-id="element-2240">
              <div className="flex items-center gap-2" data-id="element-2241">
                <div className="w-5 h-0.5 border-t-2 border-dashed border-gray-400" data-id="element-2242"></div>
                <span className="font-medium text-gray-600" data-id="element-2243">Industry</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-2244">
                <div className="w-5 h-0.5 bg-gray-900" data-id="element-2245"></div>
                <span className="font-medium text-gray-900" data-id="element-2246">DBT</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-2247">
                <div className="w-5 h-0.5 bg-red-600" data-id="element-2248"></div>
                <span className="font-medium text-red-600" data-id="element-2249">Your AR</span>
              </div>
            </div>
          </div>
          <p className="text-xs text-gray-500 mb-6 max-w-md leading-relaxed" data-id="element-2250">
            Payment behavior has severely deteriorated over the past year, with
            DBT spiking from 15 to 45 days.
          </p>
          <div className="flex-1 min-h-[250px] w-full mt-auto" data-id="element-2251">
            <ResponsiveContainer width="100%" height="100%" data-id="element-2252">
              <LineChart data={dbtData} margin={{
              top: 5,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-2253">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-2254" />
                <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} dy={10} data-id="element-2255" />
                <YAxis axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} domain={[0, 50]} ticks={[0, 10, 20, 30, 40, 50]} data-id="element-2256" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                padding: '12px'
              }} data-id="element-2257" />
                <Line type="monotone" dataKey="industry" name="Industry" stroke="#9ca3af" strokeWidth={2} strokeDasharray="5 5" dot={false} activeDot={{
                r: 6,
                fill: '#9ca3af'
              }} data-id="element-2258" />
                <Line type="monotone" dataKey="dbt" name="DBT" stroke="#111827" strokeWidth={2} dot={false} activeDot={{
                r: 6,
                fill: '#111827'
              }} data-id="element-2259" />
                <Line type="monotone" dataKey="yourAR" name="Your AR" stroke="#dc2626" strokeWidth={3} dot={false} activeDot={{
                r: 6,
                fill: '#dc2626'
              }} data-id="element-2260" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Trade Payment Aging - SEVERELY PAST DUE */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-2261">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-8 gap-4" data-id="element-2262">
          <div data-id="element-2263">
            <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2264">
              Trade Payment Information
            </h2>
            <div className="flex items-center gap-3 text-sm" data-id="element-2265">
              <span className="font-medium text-gray-900 bg-gray-100 px-2.5 py-1 rounded-md" data-id="element-2266">
                Total Trade Lines: 70
              </span>
              <span className="text-gray-500" data-id="element-2267">
                Updated Monthly - Next Update 04/01/2026
              </span>
            </div>
          </div>
        </div>

        {/* Table - Showing severe past due */}
        <div className="overflow-x-auto mb-10 border border-gray-200 rounded-xl" data-id="element-2268">
          <table className="w-full text-left border-collapse" data-id="element-2269">
            <thead data-id="element-2270">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-2271">
                <th className="px-6 py-4 text-sm font-bold text-gray-900" data-id="element-2272">
                  Status
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-2273">
                  Current
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-2274">
                  1-30
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-2275">
                  31-60
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-2276">
                  61-90
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-2277">
                  91+
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-100" data-id="element-2278">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-2279">
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-2280">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-2281">
                  Paid
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2282">
                  $3,200,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2283">
                  $1,800,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2284">
                  $950,000
                </td>
                <td className="px-6 py-4 text-sm text-orange-600 text-right" data-id="element-2285">
                  $620,000
                </td>
                <td className="px-6 py-4 text-sm text-red-600 text-right" data-id="element-2286">
                  $430,000
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-2287">
                  $7,000,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-2288">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-2289">
                  Outstanding
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2290">
                  $280,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2291">
                  $350,000
                </td>
                <td className="px-6 py-4 text-sm text-orange-600 text-right" data-id="element-2292">
                  $480,000
                </td>
                <td className="px-6 py-4 text-sm text-red-600 text-right" data-id="element-2293">
                  $420,000
                </td>
                <td className="px-6 py-4 text-sm text-red-600 text-right font-bold" data-id="element-2294">
                  $280,000
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-2295">
                  $1,810,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-2296">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-2297">
                  Payment Experiences
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2298">
                  28
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2299">
                  18
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2300">
                  12
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2301">
                  8
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-2302">
                  4
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-2303">
                  70
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Bar Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-2304">
          {/* Paid Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-2305">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-2306">
              <div className="w-2 h-6 bg-green-600 rounded-full" data-id="element-2307"></div>
              Paid History
            </h3>
            <div className="h-64 w-full" data-id="element-2308">
              <ResponsiveContainer width="100%" height="100%" data-id="element-2309">
                <BarChart data={paidData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-2310">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-2311" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-2312" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000000}M`} data-id="element-2313" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000000).toFixed(1)}M`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-2314" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '1-30') fill = '#84cc16';
                  if (name === '31-60') fill = '#facc15';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-2316" />;
                }} data-id="element-2315" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Outstanding Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-2317">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-2318">
              <div className="w-2 h-6 bg-blue-600 rounded-full" data-id="element-2319"></div>
              Outstanding Balance
            </h3>
            <div className="h-64 w-full" data-id="element-2320">
              <ResponsiveContainer width="100%" height="100%" data-id="element-2321">
                <BarChart data={outstandingData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-2322">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-2323" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-2324" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000}K`} data-id="element-2325" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000).toFixed(0)}K`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-2326" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '1-30') fill = '#84cc16';
                  if (name === '31-60') fill = '#facc15';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-2328" />;
                }} data-id="element-2327" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>

      {/* Trade Spend by Industry Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-2329">
        {/* Trade Spend Donut Chart */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-1" data-id="element-2330">
          <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-2331">
            Trade Spend by Industry
          </h2>
          <div className="relative h-64 w-full mb-8" data-id="element-2332">
            <ResponsiveContainer width="100%" height="100%" data-id="element-2333">
              <PieChart data-id="element-2334">
                <Pie data={tradeSpendData} cx="50%" cy="50%" innerRadius={70} outerRadius={100} paddingAngle={2} dataKey="value" stroke="none" data-id="element-2335">
                  {tradeSpendData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-2336" />)}
                </Pie>
                <Tooltip formatter={(value: any) => `$${(value / 1000).toFixed(0)}K`} contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }} data-id="element-2337" />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" data-id="element-2338">
              <span className="text-2xl font-black text-gray-900" data-id="element-2339">$1.81M</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-2340">
                Total Spend
              </span>
            </div>
          </div>

          {/* Custom Legend */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-2341">
            {tradeSpendData.map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-2342">
                <div className="w-3 h-3 rounded-full" style={{
              backgroundColor: item.color
            }} data-id="element-2343"></div>
                <span className="text-sm text-gray-600" data-id="element-2344">
                  {item.name} {item.percentage}%
                </span>
              </div>)}
          </div>
        </div>

        {/* Payment Aging by Industry */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-2" data-id="element-2345">
          <div className="flex justify-between items-center mb-8" data-id="element-2346">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-2347">
              Payment Aging by Industry
            </h2>
            <div className="flex bg-gray-100 rounded-lg p-1" data-id="element-2348">
              <button className="px-3 py-1 text-sm font-medium bg-white shadow-sm rounded-md text-gray-900" data-id="element-2349">
                %
              </button>
              <button className="px-3 py-1 text-sm font-medium text-gray-500 hover:text-gray-900" data-id="element-2350">
                $
              </button>
            </div>
          </div>

          <div className="space-y-6" data-id="element-2351">
            {paymentAgingData.map((item, index) => <div key={index} className="flex flex-col gap-2" data-id="element-2352">
                <div className="flex justify-between items-end" data-id="element-2353">
                  <span className="text-sm font-medium text-gray-700" data-id="element-2354">
                    {item.industry}
                  </span>
                  <span className="text-sm text-gray-500" data-id="element-2355">
                    {item.total} ({item.trades})
                  </span>
                </div>
                {/* Stacked Bar */}
                <div className="h-6 w-full flex rounded-sm overflow-hidden" data-id="element-2356">
                  {item.current > 0 && <div style={{
                width: `${item.current}%`
              }} className="bg-[#16a34a] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-2357">
                      {item.current > 10 && <span className="text-[10px] font-bold text-white" data-id="element-2358">
                          {item.current}%
                        </span>}
                    </div>}
                  {item.days1to30 > 0 && <div style={{
                width: `${item.days1to30}%`
              }} className="bg-[#84cc16] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-2359">
                      {item.days1to30 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-2360">
                          {item.days1to30}%
                        </span>}
                    </div>}
                  {item.days31to60 > 0 && <div style={{
                width: `${item.days31to60}%`
              }} className="bg-[#facc15] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-2361">
                      {item.days31to60 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-2362">
                          {item.days31to60}%
                        </span>}
                    </div>}
                  {item.days61to90 > 0 && <div style={{
                width: `${item.days61to90}%`
              }} className="bg-[#f59e0b] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-2363">
                      {item.days61to90 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-2364">
                          {item.days61to90}%
                        </span>}
                    </div>}
                  {item.days91plus > 0 && <div style={{
                width: `${item.days91plus}%`
              }} className="bg-[#dc2626] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-2365">
                      {item.days91plus > 10 && <span className="text-[10px] font-bold text-white" data-id="element-2366">
                          {item.days91plus}%
                        </span>}
                    </div>}
                </div>
              </div>)}
          </div>

          <div className="mt-8 text-center border-t border-gray-100 pt-4" data-id="element-2367">
            <button className="text-indigo-600 text-sm font-medium hover:text-indigo-700 uppercase tracking-wider" data-id="element-2368">
              Show More
            </button>
          </div>
        </div>
      </div>
    </div>;
}